<div
  class="outline-container"
  [class.selected]="isSelected$ | async"
  [style.padding.px]="padding"
>
  <ng-content></ng-content>
</div>
